module.exports = __webpack_public_path__ + "img/chat.64fd5a4e.png";